import { SyntheticEvent, useCallback, useRef } from "react";

const toYouTubeEmbed = (url: string) => {
  // YouTube の URL なら埋め込み用 URL を返す。それ以外は null
  const m = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/
  );

  return m
    ? "https://www.youtube.com/embed/" + m[1] + "?autoplay=1&rel=0"
    : null;
};

export const useLoginHooks = () => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const frameRef = useRef<HTMLDivElement>(null);

  const onOpenClick = useCallback((src: string) => {
    const embed = toYouTubeEmbed(src);
    let player;

    if (embed) {
      player = document.createElement("iframe");
      player.src = embed;
      player.title = "説明動画";
      player.allow =
        "autoplay; encrypted-media; picture-in-picture; fullscreen";
      player.allowFullscreen = true;
    } else {
      player = document.createElement("video");
      player.src = src;
      player.controls = true;
      player.autoplay = true;
      player.playsInline = true;
    }

    if (player) {
      frameRef.current?.replaceChildren(player);
      dialogRef.current?.showModal();
    }
  }, []);

  const onClose = useCallback(() => {
    // 閉じるときは動画を破棄して再生を止める
    frameRef.current?.replaceChildren();
    if (dialogRef.current?.open) dialogRef.current?.close();
  }, []);

  const onDialogCancel = useCallback(
    (e: SyntheticEvent<HTMLDialogElement, Event>) => {
      e.preventDefault();
      onClose();
    },
    [onClose]
  );

  const onDialogClick = useCallback(
    (e: SyntheticEvent<HTMLDialogElement, Event>) => {
      // 背景（動画の外側）クリックで閉じる
      if (e.target === dialogRef.current) onClose();
    },
    [onClose]
  );

  const onIntroVideoCloseClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const onIntroVideoOpenClick = useCallback(
    (videoSrc: string) => {
      onOpenClick(videoSrc);
    },
    [onOpenClick]
  );

  return {
    dialogRef,
    frameRef,

    onOpenClick,
    onClose,
    onDialogCancel,
    onDialogClick,
    onIntroVideoCloseClick,
    onIntroVideoOpenClick
  };
};
